import { useTranslation } from 'react-i18next';

import clsx from 'clsx';

import { TestIds } from '@/shared/test-ids';
import { useSupportChatStore } from '@/store/supportChat';

import { ChatBubbleIcon } from './SupportChatIcons';

type SupportChatHelpButtonProps = {
  className?: string;
};

// Opens the chat from a page header on phones, where the floating launcher is hidden.
export const SupportChatHelpButton = ({ className }: SupportChatHelpButtonProps) => {
  const [t] = useTranslation('common');
  const setIsOpen = useSupportChatStore((state) => state.setIsOpen);

  return (
    <button
      type='button'
      aria-label={t('help')}
      data-testid={TestIds.supportChat.helpButton}
      className={clsx('flex items-center text-primary-blue', className)}
      onClick={() => setIsOpen(true)}>
      <ChatBubbleIcon className='size-6' />
    </button>
  );
};
